import { render } from "./Auth.vue?vue&type=template&id=4fe87db0&ts=true"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"

import "./Auth.vue?vue&type=style&index=0&id=4fe87db0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__